import React from "react";
import { Link } from "react-router-dom";

export default function Footer({ config }) {
  return (
    <footer className="border-t border-white/5 bg-black/70 mt-24 py-10 pb-28">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/40 font-mono uppercase tracking-widest">
        <div>© {new Date().getFullYear()} {config?.artist_name || "Paraíso DJ"}</div>
        <div className="flex gap-4">
          <Link to="/contact" className="hover:text-red-500">Contacto</Link>
          <Link to="/packs" className="hover:text-red-500">Packs</Link>
          <Link to="/remixes" className="hover:text-red-500">Remixes</Link>
        </div>
      </div>
    </footer>
  );
}
